import styles from './FilterSidebar.module.css';
import { connect } from 'react-redux';
import { ParkingFilters, ParkingCapacityLegend, ParkingTypeLegend } from './ParkingFilters';
import { FunctionalAreasFilter } from './FunctionalAreasFilter';
import { RestrictionZonesV2Legend } from './RestrictionZonesV2Legend';
import { FeatureAreasLegend } from './FeatureAreasLegend';
import { BikePathLegend } from './BikePathLegend';
import { SupposedBikePathLegend } from './SupposedBikePathLegend';
import { AggStartsAugustFilter } from './AggStartTripsAugust';
import { AggFinishAugustFilter } from './AggFinishTripsAugust';
import { AggregatedDiffStartFinishLegend } from './AggregatedDiffStartFinishLegend';
import { AggregatedDiffStartFinishLegendAugust } from './AggregatedDiffStartFinishLegendAugust';
import { AggScooterBalanceLegend } from './AggScooterBalance';
import { LanduseLegend } from './LanduseLegend';
import { PoiLegend } from './PoiLegend';
import { PopulationLegend } from './PopulationLegend';
import { ParkingDensityLegend } from './ParkingDensityLegend';
import { CurScootresParkingLegend, CurrentScootersFilter } from './CurScootresParkingLegend';
import { ChangeBatteryLegend } from './ChangeBatteryLegend';
import { CurDeficitLegend } from './CurDeficitScootersLegend';
import { CurProficitLegend } from './CurProficitScootersLegend';
// import { AggTracksAugustH3Filter } from './AggTracksAugustH3Filter';  // Отключён
import { AggTripsAugustH3Filter } from './AggTripsAugustH3Filter';
import { WalkscoreFilter } from './WalkscoreFilter';
import { AdminAggTracksV2Filter } from './AdminAggTracksV2Filter';
import { AggTracksCohortFilter } from './AggTracksCohortFilter';
import { UserCohortsFilter } from './UserCohortsFilter';
import { AdminAggTracksMonthlyFilter } from './AdminAggTracksMonthlyFilter';
import { RechargingStatsLegend } from './RechargingStatsLegend';
import { ChargingObjectsLoadLegend } from './ChargingObjectsLoadLegend';
import { NewBuildingsLegend } from './NewBuildingsLegend';
import { IsochronesFilter } from './IsochronesFilter';
import { FinishTrackFilter, StartTrackFilter } from './StartFinishTrackFilter';
import { HousesLegend } from './HousesLegend/HousesLegend';
import { TapsNoStartsFilter } from './AggUserTapsZeroStartsLegend';
import { OpenToStartsFilter } from './AggUserOpensToStartsLegend';
import { ClassifiedParkingFilter } from './ClassifiedParkingsFilters';
import { ClassifiedParkingDayPartFilter } from './ClassifiedParkingsDayPartFilters';
import { ParkingRadiusLegend } from './ParkingRadiusLegend';
import { AggScootersDowntimeLegend } from './AggScootersDowntimeLegend';
import { AggHexRentLegend } from './AggHexRentLegend';
import { AggHexRiLegend } from './AggHexRiLegend';
import { AggHexSpeedLegend } from './AggHexSpeedLegend';
import { ScootersSpeedLegend } from './ScootersSpeedLegend/ScootersSpeedLegend';
import { LisboaZonesFilter } from './LisboaZonesFilter';
import { ClassifiedParkingRebalancedFilter } from './ClassifiedParkingsRebalancedFilters';
import { ClassifiedParkingDayPartRebalancedFilter } from './ClassifiedParkingsDayPartRebalancedFilters';
import { ClusteredTapsLegend } from './ClusteredTapsLegend';
import { ParkingProposalsLegend } from './ParkingProposalsLegend';
import { ClusteredOpensLegend } from './ClusteredOpensLegend';
import { ServiceCentersIsochronesFilter } from './IsochronesServiceCentersFilter';
import { SeviceCentersFilter } from './ServiceCentersFilters';
import { AnalyticAreasFilter } from './AnalyticAreasFilter';
import { TransportIsochronesLegend } from './IsochronesTransportLegend';
import { AggFailedTripsLegend } from './AggFailedTripsLegend';
import { RebalanceParkingLegend } from './RebalanceParkingLegend';
import { RebalanceForecastTabaLegend } from './RebalanceForecastTabaLegend';
import { FactRebalanceFilter, FactRebalanceLegend } from './FactRebalanceFilter';
import { ChainStatisticsLegend } from './ChainStatisticsLegend';
import { ParkingFilters1300 } from './Parkings1300';
import { ParkingsAlertsFilter } from './ParkingsAlerts';
import { ParkingsBookingsDateFilter } from './ParkingsBooking';
import { IsoParkingsWithScootersFilter } from './IsochronesWithScootersFilters';
import { ParkingRadiusFilter } from './ParkingRadiusFilter';
import { CorrespondingMatrixFilters } from './CorrespondingMatrixFilters';
import { RidingZonesCompetitorsFilter } from './RidingZonesCompetitorsFilter';
import { CompetitorsParkingsChangesFilter } from './CompetitorsParkingsChangesFilter';
import { CompetitorsZonesChangesFilter } from './CompetitorsZonesChangesFilter';
import { ClusteredAlertsCombinedFilter, ClusteredAlertsLegend } from './ClusteredAlertsFilter';
import { ClassifiedParkingsWeekdaysFilter } from './ClassifiedParkingsWeekdayFilters';
import { ClassifiedParkingsRebalancedWeekdaysFilter } from './ClassifiedParkingsRebalancedWeekdayFilters';
import { SpeedLimitsFilter } from './SpeedLimitsFilter';
import { AggHexForParkingsFilter } from './AggHexForParkingsFilter';
import { DynamicTariffVoronoiLegend } from './DynamicTariffVoronoi';
import { DynamicTariffVoronoiLegendH3 } from './DynamicTariffVoronoiH3';
import { DynamicTariffZonesLegend } from './DynamicTariffZonesLegend';
import { ParkingsAlertsPointsPeriodFilter } from './ParkingsAlertsPointsFilter';
import { ParkingsAlertsPointsDeviceFilter } from './ParkingsAlertsPointsDeviceFilter';
import { ParkingsAlertsPointsTypeErrorFilter } from './ParkingsAlertsPointsTypeErrorFilter';
import { TapsFilter, OpensFilter } from './TapsFilter';
import { StartsCompetitorsFilter } from './StartCompetitorsFilter';
import { PanoramaFilter } from './PanoramaFilter';
import { OaCompetitorsFilter } from './OperationAreasCompetitorsFilter';
import { ParkingDowntime48hLegend } from './ParkingDowntime48h';
import { SBWithErrorsFilter } from './SbWithErrorsFilter';
import { TapsOpensHistFilter } from './TapsOpensHistFilter';
import { OaRotationFilter, OaRotationDevFilter } from './OperationAreasFilter';

import { RestrictionCompetitorsAreasFilter } from './RestrictionCompetitorsAreasFilter';
import { CompetitorsParkingsFilter } from './CompetitorsParkingsFilter';
import { FleetTransfersFilter } from './FleetTransfersFilter';
import { OsmAdminBoundariesFilter } from './OsmAdminBoundariesFilter';
import React from 'react';
import { StartsByHourFilter, StartsByHourLegend } from './StartsByHourFilter';
import { ScrTracksFilter } from './ScrTracksFilter';
import { SimAccidentsFilter } from './SimAccidentsFilter';
import { TerrainPanel } from './TerrainPanel';
import { SlopeLegend } from './SlopeLegend';
import { AspectLegend } from './AspectLegend';
import { CompositeLegend } from './CompositeLegend';
import { RegToTripConversionLegend } from './RegToTripConversionLegend/RegToTripConversionLegend';
import { H3GridLegend } from './H3GridLegend/H3GridLegend';
import { LostDevicesLegend } from './LostDevicesLegend/LostDevicesLegend';
import { GhostDevicesLegend } from './GhostDevicesLegend/GhostDevicesLegend';
import { LostSearchLegend } from './LostSearchLegend/LostSearchLegend';
import { LostDevicesH3Legend } from './LostDevicesH3Legend/LostDevicesH3Legend';
import { WifiApLegend } from './WifiApLegend/WifiApLegend';
import { RouteAnomaliesH3Filter } from './RouteAnomaliesH3Filter';
import { OperationAreaErrLegend } from './OperationAreaErrLegend/OperationAreaErrLegend';
import { UrbanTypologyLegend } from './UrbanTypologyLegend/UrbanTypologyLegend';


const FilterSidebarComponent = ({ isVisible = true, onContentChange, hasContent = false }) => {
    const legendGridRef = React.useRef(null);
    const isMobile = window.innerWidth <= 850;
    // На десктопе: показываем только если есть контент
    // На мобильных: зависит от isVisible
    const shouldShow = isMobile ? isVisible : hasContent;

    // Проверяем есть ли видимый контент в legendGrid
    React.useEffect(() => {
        if (!onContentChange || !legendGridRef.current) return;

        let isMounted = true;

        const checkForVisibleContent = () => {
            try {
                if (!isMounted || !legendGridRef?.current) return;

                // Получаем прямых дочерних элементов legendGrid
                const children = Array.from(legendGridRef.current.children);
                let hasVisibleContent = false;

                for (const child of children) {
                    // Проверяем стиль и наличие высоты элемента
                    const style = window.getComputedStyle(child);
                    // Элемент видимый если display не none и есть высота или содержимое
                    if (style.display !== 'none' && (child.offsetHeight > 0 || child.textContent.trim())) {
                        hasVisibleContent = true;
                        break;
                    }
                }

                if (isMounted) {
                    onContentChange(hasVisibleContent);
                }
            } catch (e) {
                // Игнорируем ошибки если компонент размонтирован
                if (isMounted) {
                    console.warn('Error checking filter content:', e);
                }
            }
        };

        // Первая проверка
        setTimeout(checkForVisibleContent, 100);

        // MutationObserver для отслеживания изменений
        const observer = new MutationObserver(checkForVisibleContent);
        observer.observe(legendGridRef.current, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: [ 'style', 'class' ],
        });

        // Также проверяем при resize
        const handleResize = () => checkForVisibleContent();
        window.addEventListener('resize', handleResize);

        return () => {
            isMounted = false;
            observer.disconnect();
            window.removeEventListener('resize', handleResize);
        };
    }, [ onContentChange ]);

    return (
        <div
            className={`${styles.mainLeg}
                ${isMobile && !shouldShow ? styles.filterHidden : ''}
                ${!isMobile && !hasContent ? styles.contentHidden : styles.contentVisible}`}
        >
            <div
                id="legend-grid"
                className={styles.legendGrid}
                ref={legendGridRef}
            >
                <ParkingFilters />
                <BikePathLegend />
                <FunctionalAreasFilter />
                <RestrictionZonesV2Legend />
                <FeatureAreasLegend />
                <SupposedBikePathLegend />
                <AggStartsAugustFilter />
                <AggFinishAugustFilter />
                <AggregatedDiffStartFinishLegend />
                <AggregatedDiffStartFinishLegendAugust />
                <LanduseLegend />
                <PopulationLegend />
                <ParkingDensityLegend />
                <PoiLegend />
                <HousesLegend />
                <TerrainPanel />
                <SlopeLegend />
                <AspectLegend />
                <CompositeLegend />
                <CurrentScootersFilter />
                <CurScootresParkingLegend />
                <CurDeficitLegend />
                <CurProficitLegend />
                <AggScooterBalanceLegend />
                <NewBuildingsLegend />
                {/* <AggTracksAugustH3Filter /> */}
                <AggTripsAugustH3Filter />
                <WalkscoreFilter />
                <AdminAggTracksV2Filter />
                <AggTracksCohortFilter />
                <UserCohortsFilter />
                <AdminAggTracksMonthlyFilter />
                <RouteAnomaliesH3Filter />
                <ChangeBatteryLegend />
                <IsochronesFilter />
                <StartTrackFilter />
                <FinishTrackFilter />
                <TapsNoStartsFilter />
                <OpenToStartsFilter />
                <ClassifiedParkingFilter />
                <ParkingRadiusLegend />
                <ParkingCapacityLegend />
                <ParkingTypeLegend />
                <AggScootersDowntimeLegend />
                <ClassifiedParkingDayPartFilter />
                <AggHexRentLegend />
                <AggHexRiLegend />
                <AggHexSpeedLegend />
                <ScootersSpeedLegend />
                <LisboaZonesFilter />
                <ClassifiedParkingRebalancedFilter />
                <ClassifiedParkingDayPartRebalancedFilter />
                <ClusteredTapsLegend />
                <ParkingProposalsLegend />
                <ClusteredOpensLegend />
                <ServiceCentersIsochronesFilter />
                <SeviceCentersFilter />
                <AnalyticAreasFilter />
                <CorrespondingMatrixFilters />
                <TransportIsochronesLegend />
                <AggFailedTripsLegend />
                <RebalanceParkingLegend />
                <RebalanceForecastTabaLegend />
                <FactRebalanceFilter />
                <FactRebalanceLegend />
                <ChainStatisticsLegend />
                <RechargingStatsLegend />
                <ChargingObjectsLoadLegend />
                <ParkingFilters1300 />
                <ParkingsAlertsFilter />
                <ParkingsBookingsDateFilter />
                <IsoParkingsWithScootersFilter />
                <ParkingRadiusFilter />
                <ClusteredAlertsCombinedFilter />
                <ClusteredAlertsLegend />
                <ClassifiedParkingsWeekdaysFilter />
                <ClassifiedParkingsRebalancedWeekdaysFilter />
                <SpeedLimitsFilter />
                <AggHexForParkingsFilter />
                <DynamicTariffVoronoiLegend />
                <DynamicTariffVoronoiLegendH3 />
                <DynamicTariffZonesLegend />
                <StartsByHourFilter />
                <StartsByHourLegend />
                <ScrTracksFilter />
                <SimAccidentsFilter />
                <ParkingsAlertsPointsPeriodFilter />
                <ParkingsAlertsPointsTypeErrorFilter />
                <ParkingsAlertsPointsDeviceFilter />
                <TapsFilter />
                <OpensFilter />
                <StartsCompetitorsFilter />
                <PanoramaFilter />
                <OaCompetitorsFilter />
                <ParkingDowntime48hLegend />
                <RegToTripConversionLegend />
                <H3GridLegend />
                <LostDevicesLegend />
                <LostDevicesH3Legend />
                <WifiApLegend />
                <GhostDevicesLegend />
                <LostSearchLegend />
                <OperationAreaErrLegend />
                <UrbanTypologyLegend />
                <SBWithErrorsFilter />
                <TapsOpensHistFilter />
                <OaRotationFilter />
                <OaRotationDevFilter />
                <RestrictionCompetitorsAreasFilter />
                <RidingZonesCompetitorsFilter />
                <CompetitorsZonesChangesFilter />
                <CompetitorsParkingsChangesFilter />
                <CompetitorsParkingsFilter />
                <FleetTransfersFilter />
                <OsmAdminBoundariesFilter />
            </div>
        </div>
    );
};

export const FilterSidebar = connect()(FilterSidebarComponent);
